import AsyncSelectField from "@components/fields/react-select/async-select";
import CommonModal from "@components/ui-components/modal";
import FormView from "@components/views/form-view";
import InputField from "@components/fields/input-field";
import Select from "@components/fields/react-select/select";
import size from "lodash/size";
import useFilters from "@src/views/common/hooks/use-filter";
import useUpsert from "./use-upsert";
const ROLE_OPTIONS = [
    {
        label: "Admin",
        value: "admin"
    },
    {
        label: "Sub-Admin",
        value: "subadmin"
    },
    {
        label: "Affiliate Manager",
        value: "affiliate_manager"
    }
];
const Upsert = props => {

    const {
        modalConfig: { row, isOpen },
        handleModal
    } = props;

    const isEdit = !!size(row);
    
    const { onSubmit, loading, isDirty, methods } = useUpsert({ ...props, isEdit });
    const {
        control,
        formState: { errors }
    } = methods;
    const { loadAsyncOptions } = useFilters();
    
    const content = [
        {
            leftChild: {
                title: "Basic Details",
                desc : "Enter basic details like name, phone etc."
            },
            rightChild: (
                <>
                    <InputField
                        label="Name"
                        id="name"
                        name="name"
                        required
                        control={control}
                        errors={errors}/>
                    <InputField
                        label="Email"
                        id="email"
                        name="email"
                        required
                        control={control}
                        errors={errors}/>
                    <InputField
                        label="Phone"
                        id="phone"
                        name="phone"
                        control={control}
                        errors={errors}/>
                    <InputField
                        label="Skype"
                        id="skype_id"
                        name="skype_id"
                        control={control}
                        errors={errors}/>
                    <Select
                        label="Role"
                        id="role"
                        name="role"
                        required
                        control={control}
                        errors={errors}
                        options={ROLE_OPTIONS}/>
                    <AsyncSelectField
                        loadOptions={(value, callback) => loadAsyncOptions(
                            { value,
                                callback,
                                type   : "tags",
                                context: {
                                    context: "people"
                                } 
                            }
                        )
                        }
                        defaultOptions
                        id="tags"
                        isClearable
                        label="Tags"
                        isMulti
                        name="tags"
                        control={control}
                        errors={errors}/>
                </>
            )
        }
    ];
    
    return (
        <CommonModal
            type="extraLarge"
            isOpen={isOpen}
            confirmButton={{
                txt    : isEdit ? "Update" : "Add",
                icon   : "content-save",
                onClick: onSubmit,
                loading
            }}
            isDirty={isDirty}
            handleModal={handleModal}
            title={`${!isEdit ? "Add" : "Edit"} People`}
            body={<FormView content={content} />}/>
    );
};

export default Upsert;
